import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import React, { Component } from 'react';
import { TeamMultiSelect } from '../team-multi-select/TeamMultiSelect';
import { getDelegateTeams } from '../../main/main-content/alerts/delegate/redux/selectors';
import { fetchDelegateTeams } from '../../main/main-content/alerts/delegate/redux/actions';

/*
  The teams to delegate an alert to, in the dialog that does it. It reads GET /alerts/delegate-teams, which needs the permission to
  delegate and not the one to list the teams (GET /teams): a user who may delegate has no other use for the list of the teams.
*/
class TeamMultiSelectContainer extends Component {
    componentDidMount() {
        this.props.fetchTeams && this.props.fetchTeams();
    }

    render() {
        return (
            <TeamMultiSelect
                teams={this.props.teams}
                onChange={this.props.onChange}
            />
        );
    }
}

const mapStateToProps = state => ({
    teams: getDelegateTeams(state)
});

const mapDispatchToProps = dispatch => ({
    fetchTeams: () => dispatch(fetchDelegateTeams())
});

export default withRouter(
    connect(mapStateToProps, mapDispatchToProps)(TeamMultiSelectContainer)
);
